import axios from "axios";
import reports from "../../models/reportes/reports";
import procedures from "../../models/reportes/procedures";
import reportes from "../../store/reportes/reports";
import lookups from "../../models/reportes/lookups";
import lookupData from "../../models/reportes/lookupData";
import permissions from "../../models/reportes/permissions";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getReports() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const operId = localStorage.getItem("operId");

    return axios
      .get(`${url}/reportes/oper/${operId}`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return reports.fromJson(item);
        });
      });
  }

  new(items) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const operId = Number(localStorage.getItem("operId"));
    const rolId = Number(localStorage.getItem("rolId"));
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {
      nombre: items.name,
      descripcion: items.description,
      procedimiento: items.process,
      parameters: items.parameters ? items.parameters : undefined,
      tipoRep: items.type,
      etiquetas: items.tags,
    };
    if (items.type == "Pu") {
      payload.roles = [
        {
          rolId: rolId,
          rolPermiso: "P",
        },
      ];
    } else {
      payload.operId = operId;
    }
    return axios.post(`${url}/reportes`, payload, { headers });
  }

  edit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let payload = {
      nombre: data.name,
      descripcion: data.description,
      procedimiento: data.process,
      tipoRep: data.type,
      operId: data.operId == undefined ? undefined : parseInt(data.operId, 10),
      parameters: data.parameters ? data.parameters : undefined,
      etiquetas: data.tags,
    };

    return axios
      .patch(`${url}/reportes/${data.id}`, payload, { headers })
      .then(() => { });
  }

  delete(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/reportes/${data.id}`, { headers });
  }

  execute(items) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const operId = Number(localStorage.getItem("operId"));
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    items.operId = operId;
    return axios
      .post(`${url}/reportes/exec`, items, { headers })
      .then((response) => {
        if (response.data && response.data.length > 0) {
          const firstRow = response.data[0];
          const rows = response.data;
          const headers = Object.keys(firstRow);
          reportes.commit("setHeaders", headers);
          reportes.commit("setRows", rows);
        }
        return response.data;
      });
  }

  getProcedures() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/reportes/procedures`, { headers })
      .then(({ data }) => {
        return data.map((item) => {
          return procedures.fromJson(item);
        });
      });
  }

  getLookups() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/reportes/lookups`, { headers })
      .then(({ data }) => {
        return data.map((item) => {
          return lookups.fromJson(item);
        });
      });

  }
  //se debe cambiar por {procedure}&{operid}
  getLookupData(lookup) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const operId = Number(localStorage.getItem("operId"));
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/reportes/lookupdata/${lookup}&${operId}`, { headers })
      .then(({ data }) => {
        return data.map((item) => {
          return lookupData.fromJson(item);
        });
      });

  }

  getReportPermissions(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios
      .get(`${url}/reportes/${id}/roles`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return permissions.fromJson(item);
        });
      });
  }

  addReportPermissions(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {
      reporteId: data.reporteId,
      rolId: data.rolId,
      rolPermiso: data.rolPermiso
    };

    return axios.post(`${url}/reportes/roles`, payload, { headers }).then((data) => {
      return permissions.fromJson(data.data);
    });
  }

  deleteReportPermissions(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/reportes/roles/${data.reporteId}&${data.rolId}`, { headers });
  }


}
export default service;
